import { BookablePersonType } from '@sales-app/types/BookablePersonType'

import { WorkspaceView } from './workspace.type'

interface WorkspacePathProps {
  id: number
  potentialBookingId: number | null
  type: BookablePersonType
  view: WorkspaceView
}

export const getWorkspacePath = ({ id, view, type, potentialBookingId }: WorkspacePathProps) => {
  const basePath = 'active-workspace'
  const { POTENTIALBOOKING, SUMMARY } = WorkspaceView

  if (id && (type === BookablePersonType.LEAD || type === BookablePersonType.MEMBER)) {
    const _type = type.toLowerCase()
    if (view === POTENTIALBOOKING) {
      if (potentialBookingId) {
        return `/${basePath}/${_type}/${id}/${POTENTIALBOOKING}/${potentialBookingId}`
      } else {
        return `/${basePath}/${_type}/${id}/${POTENTIALBOOKING}`
      }
    } else {
      return `/${basePath}/${_type}/${id}/${SUMMARY}`
    }
  }
  return ''
}
